type CornerStatusRibbonProps = {
  label: string;
  styleClass: string;
};

export const CornerStatusRibbon = ({ label, styleClass }: CornerStatusRibbonProps) => (
  <span
    className={`pointer-events-none absolute right-0 top-0 z-0 rounded-bl-xl border-b border-l px-2.5 pb-1 pt-1.5 text-[10px] font-bold leading-tight ${styleClass}`}
    role="status"
  >
    {label}
  </span>
);
